var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyIconIndependentConsultant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.844 4.688H5.156c-.383 0-.656.3-.656.656 0 .383.273.656.656.656h5.688a.648.648 0 0 0 .656-.656c0-.356-.3-.657-.656-.657zM8.219 7.313H5.156c-.383 0-.656.3-.656.656 0 .383.273.656.656.656H8.22a.648.648 0 0 0 .656-.656c0-.356-.3-.657-.656-.657zM13.223.75h-10.5c-.985 0-1.75.793-1.75 1.75v7.848c0 .957.765 1.722 1.75 1.722h2.625v2.27c0 .273.3.41.52.273l3.417-2.57h3.938c.957 0 1.75-.793 1.75-1.723V2.5c0-.957-.766-1.75-1.75-1.75zm.464 9.625a.45.45 0 0 1-.437.438H8.875l-2.188 1.64v-1.64H2.75a.432.432 0 0 1-.438-.438V2.5a.45.45 0 0 1 .438-.438h10.5a.47.47 0 0 1 .438.438v7.875z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIconIndependentConsultant);
export default __webpack_public_path__ + "static/media/survey-icon-independent-consultant.ff5e80e264df35612f1ee6be1cdecbd5.svg";
export { ForwardRef as ReactComponent };